import * as React from "react";
import RichTextInput from "ra-input-rich-text";
import Empty from "../empty";
import {
    List,
    Create,
    Edit,
    Datagrid,
    TextField,
    SimpleForm,
    TextInput,
    ImageInput,
    ImageField,
    EditButton, SaveButton, TopToolbar, CreateButton, ExportButton, useGetIdentity,
} from 'react-admin';
import Toolbar from "@material-ui/core/Toolbar";
import {Button} from "@material-ui/core";
import {BarLoader} from "react-spinner-animated";

const postFilters = [
    <TextInput source="q" label="Search" alwaysOn/>,
];

const ToolbarButtons = (props) => (
    <TopToolbar>
        <CreateButton disabled={props.identity.admin} label={"Nuovo"}/>
        <ExportButton label={"Esporta"}/>
        {/* Add your custom actions */}
    </TopToolbar>
)

export const ProductTypeList = (props) => {
    const {identity, loading} = useGetIdentity();
    if (loading) return <BarLoader text={"Caricamento..."}
                                   center={true}/>;
    return (
        <List {...props} perPage={25} filters={postFilters} empty={<Empty/>}
              actions={<ToolbarButtons identity={identity}/>}>
            <Datagrid rowClick="edit">
                <TextField source="productName" label="Tipologia"/>
                <ImageField source="img" label="Immagine del prodotto" textAlign="center"/>
                {/* <ShowButton /> */}
                <EditButton label="Modifica"/>
            </Datagrid>
        </List>
    )
};

const PostEditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton disabled={props.identity.admin} label={"Salva"} submitOnEnter={false} redirect={props.redirect} {...props}/>
        <Button href={"#/product_type"}>Annulla</Button>
    </Toolbar>
);

export const ProductTypeCreate = (props) => {
    const {identity, loading} = useGetIdentity();
    if (loading) return <BarLoader text={"Caricamento..."}
                                   center={true}/>;
    return (
        <>
            <Create {...props}>
                <SimpleForm toolbar={<PostEditToolbar identity={identity}/>}>
                    <TextInput
                        source="productName"
                        required
                        name="productName"
                        label="Tipologia"
                        type="text"
                        id="productName"
                    />
                    <RichTextInput
                        source="description"
                        options={{multiLine: true}}
                        required
                        name="description"
                        label="Descrizione del prodotto"
                        type="text"
                        id="description"
                    />
                    <ImageInput source="pictures" label="Immagiune del prodotto" accept="image/*" multiple={false}
                                placeholder={<p>Inserisci immagine</p>}>
                        <ImageField source="src" title="title"/>
                    </ImageInput>
                </SimpleForm>
            </Create>
        </>
    )
};

export const ProductTypeEdit = (props) => {
    const {identity, loading} = useGetIdentity();
    if (loading) return <BarLoader text={"Caricamento..."}
                                   center={true}/>;

    return (
        <Edit {...props}>
            <SimpleForm toolbar={<PostEditToolbar identity={identity}/>}>
                <TextInput disabled label="Id" source="id"/>
                <TextInput disabled={identity.admin} source="productName" label="Nome del prodotto"/>
                <RichTextInput disabled={identity.admin} source="description" options={{multiLine: true}} label="Descrizione"/>
                <ImageField disabled={identity.admin} source="img" title={"Immagine"}/>
                {!identity.admin && <ImageInput source="pictures" label="Related pictures" accept="image/*" multiple={false}
                            placeholder={<p>Inserisci immagine</p>}>
                    <ImageField source="src" title="title"/>
                </ImageInput>}
            </SimpleForm>
        </Edit>
    );
}